import { dashedEnvPath, getEnvName } from './utils';

const envName = getEnvName(); // 环境变量/ 环境变量

// api接口相关
export const CASHBACK_BASE_URL = `https://api${dashedEnvPath(envName)}.cdssylkj.com`;
export const UC_API_DOMAIN = `https://uc-api${dashedEnvPath(envName)}.cdssylkj.com`;
export const TRACE_BASE_URL = `https://api${dashedEnvPath(envName)}.cdssylkj.com`;
export const TINMAN_BASE_URL = `https://api${dashedEnvPath(envName)}.cdssylkj.com`;
export const TINMAN_BASE_C_URL = `https://api${dashedEnvPath(envName)}.cdssylkj.com`;
export const MALL_BASE_URL = `https://api${dashedEnvPath(envName)}.cdssylkj.com/mall/product/api`;
export const PAY_BASE_URL = `https://api${dashedEnvPath(envName)}.cdssylkj.com/mall/pay`;
export const ORDER_BASE_URL = `https://api${dashedEnvPath(envName)}.cdssylkj.com/mall/order`;

export const MALL_ADDRESS_LIST = `https://mall${dashedEnvPath(envName)}.cdssylkj.com/address/list`;
export const MALL_ORDER_LIST = `https://mall${dashedEnvPath(envName)}.cdssylkj.com/order/list`;
// 订单详情页
export const MALL_ORDER_DETAIL = `https://mall${dashedEnvPath(
  envName
)}.cdssylkj.com/order/detail?orderId=`;
export const EDU_POINTS = `https://edu${dashedEnvPath(envName)}.cdssylkj.com/ap/points/detail`; // 矩阵无成长豆相关，暂时保留
// 抽奖的填地址
export const ACT_ADDRESS = `https://act${dashedEnvPath(
  envName
)}.cdssylkj.com/actAddress/address?rid=`;
// 打开APP地址
export const OPEN_APP = `https://act${dashedEnvPath(
  envName
)}.cdssylkj.com/act2/qwerty/openApp.html?url=`;
// 邀请明细的填地址
export const Price_ADDRESS = `https://act${dashedEnvPath(envName)}.cdssylkj.com/team/address`;
// 专辑详情页
export const READ_HUB = `https://jojoread${dashedEnvPath(
  envName
)}.cdssylkj.com/web/tellStories/groupon-redirect-page`; // 矩阵无专辑相关，暂时保留

// 包名
export const PACKAGE_NAME = 'mp.tinman.JoJoRead';

// 授权失效之后进入链接地址
export const AUTH_SIGN_URL = `https://uc-api${dashedEnvPath(
  envName
)}.cdssylkj.com/page/wechatMp/portal/entrance`;
export const AUTH_REDIRECT_PARAMS = 'au_prms';

// 非静默登陆登陆也
export const AUTH_INPUT_LOGIN = `https://act${dashedEnvPath(envName)}.cdssylkj.com//account/login`;

// 新的微信授权接口
export const AUTH_SIGN_URL_NEW = `https://uc-api${dashedEnvPath(
  envName
)}.cdssylkj.com/api/user-center/wechatMp/login`;

export const PLACEHOLDER_MAP =
  'https://jojopublic.jojoread.com/mall/mall-cashback/activity/image/202104/e701cbe2324347ad8c2affc34cc0bf71.jpg';

export const SERVICE_URL = `https://act${dashedEnvPath(
  envName
)}.cdssylkj.com/transform/customerCenter?fromType=ORDER`;

export const SENSORS_SERVER_URL = 'https://sensors.tinman.cn/sa?project=jojo_matrix';

export const READ_BASE_URL = 'https://jojoread.cdssylkj.com';
